@if (isLoadingEmployerProviders() && isLoadingFriendsAndFamilyConfig()) {
<app-spinner data-test-id="account-manage-spinner"></app-spinner>
} @else {<app-card
  [background]="!readMode()"
  [partialFullHeight]="true"
  size="large"
  [spacingBottom]="Spacing.NONE"
>
  <section>
    <form (submit)="onSubmit($event)">
      <header class="tenant-features-header">
        <h1>Tenant Features</h1>
        <app-form-action-button
          [type]="readMode() ? 'edit' : 'save'"
          [disabled]="!isConfigurationsValid()"
          [buttonType]="
            readMode() ? NativeButtonType.BUTTON : NativeButtonType.SUBMIT
          "
          (handleClick)="handleEdit()"
          data-test-id="tenant-configuration-save-edit-button"
        ></app-form-action-button>
      </header>
      @for (feature of configurationFeatures(); track feature) {
      <div class="feature-section">
        <p class="feature-title">{{ feature.title }}</p>
        <p class="feature-description">{{ feature.description }}</p>
        <app-toggle
          class="feature-toggle"
          (handleChecked)="handleCheck(feature)"
          [checked]="feature.value"
          [color]="ToggleHexColor.GREEN"
          [disabled]="readMode()"
          size="small"
          [attr.data-test-id]="'feature-' + feature.key + '-toggle'"
        ></app-toggle>
        @if (feature.key === 'employerProvider' && feature.value) {
        <app-select-dropdown
          class="feature-employer-provider"
          [options]="employerProvidersNames"
          [selected]="employerProviderSelected()"
          [disabled]="readMode()"
          (handleSelect)="handleEmployerProvider($event)"
        ></app-select-dropdown>
        } @if (feature.key === 'flex' && feature.value) {
        <div class="feature-flex-wrapper">
          <p class="feature-label">Enable Flex Tile</p>
          <app-toggle
            class="feature-toggle"
            (handleChecked)="handleFlexTile()"
            [checked]="flexTileEnabled"
            [color]="ToggleHexColor.GREEN"
            [disabled]="readMode()"
            size="small"
            [attr.data-test-id]="'feature-flex-toggle'"
          ></app-toggle>
        </div>
        } @if (feature.key === 'gympass' && feature.value) {
        <div
          class="dropdown-group"
          [style.visibility]="
            gympassFeatureConfig()?.defaultTier === 'None'
              ? 'visible'
              : 'hidden'
          "
        >
          <p class="label">
            {{ 'tenantConfiguration.general.digitalMonthlyPrice' | translate }}
          </p>
          <app-select-dropdown
            [optionsObj]="formatPricesForDropdown(monthlyPrices())"
            [selected]="monthlyPrice()"
            [disabled]="readMode()"
            (handleSelect)="handleMonthlyPrice($event)"
          ></app-select-dropdown>
        </div>
        <app-gympass-feature
          data-test-id="tenant-features-gympass"
          class="feature-gympass-template"
          [(gympassFeatureConfig)]="gympassFeatureConfig"
          [readMode]="readMode()"
        />

        } @if (feature.key === 'friendsAndFamily' && feature.value) {
        <div class="tenant-features-monthly-subsidy field-group">
          <app-input
            labelData="{{
              'tenantConfiguration.general.invitesPerUser' | translate
            }}"
            variant="{{ InputVariant.OUTLINE }}"
            type="{{ InputType.NUMBER }}"
            width="{{ InputWidth.FIXED_NUMBER }}"
            size="{{ InputSize.LARGE }}"
            direction="{{ InputDirection.VERTICAL }}"
            spacingBottom="{{ InputFieldSpacing.MEDIUM }}"
            [disabled]="readMode()"
            [error]="!!errorMessages().invitesPerUser"
            data-test-id="tenant-features-input-number-of-invites"
            [min]="1"
            [max]="99"
            [inputValue]="invitesPerUserInput"
            (signalValueChanged)="handleInvitesPerUserChange($event)"
          ></app-input>
          <div
            class="dropdown-group"
            [style.visibility]="
              friendsAndFamilyTenantGympassConfig()?.defaultTier === 'None'
                ? 'visible'
                : 'hidden'
            "
          >
            <p class="label">
              {{
                'tenantConfiguration.general.digitalMonthlyPrice' | translate
              }}
            </p>
            <app-select-dropdown
              [optionsObj]="formatPricesForDropdown(monthlyPrices())"
              [selected]="friendsAndFamilyMonthlyPrice()"
              [disabled]="readMode()"
              (handleSelect)="handleFriendsAndFamilyMonthlyPrice($event)"
            ></app-select-dropdown>
          </div>
        </div>
        <app-gympass-feature
          data-test-id="tenant-features-friends-and-family-gympass"
          class="feature-gympass-template"
          [(gympassFeatureConfig)]="friendsAndFamilyTenantGympassConfig"
          [readMode]="readMode()"
        />
        } @if (feature.key === 'mfa' && feature.value) {
        <div class="feature-mfa-wrapper">
          <p class="feature-label">Enable Pin</p>
          <app-toggle
            class="feature-toggle"
            (handleChecked)="handleMfa()"
            [checked]="mfaPinEnabled"
            [color]="ToggleHexColor.GREEN"
            [disabled]="readMode()"
            size="small"
            [attr.data-test-id]="'feature-mfa-toggle'"
          ></app-toggle>
        </div>
        } @if (feature.key === 'requiresCodeToJoin' && feature.value) {
        <app-text-input
          class="feature-requires-code-to-join"
          [label]="'tenantConfiguration.general.codeToJoinMessage' | translate"
          [value]="codeToJoinMessageValue()"
          (valueChange)="handleCodeToJoinMessageChange($event)"
          [direction]="TextInputDirection.VERTICAL"
          [variant]="TextInputVariant.OUTLINE"
          [width]="TextInputWidth.FULL"
          [labelSize]="TextInputLabelSize.SMALL"
          [error]="!!errorMessages().codeToJoinMessage"
          [errorMessage]="errorMessages().codeToJoinMessage"
          [attr.data-test-id]="'feature-requires-code-to-join-input'"
        ></app-text-input>
        } @if (feature.key === 'sessionTimeout' && feature.value) {
        <app-text-input
          class="feature-session-timeout"
          label="Minutes (min: 5, max: 1440)"
          placeholder="5"
          [(value)]="sessionTimeoutValue"
          [direction]="TextInputDirection.VERTICAL"
          [variant]="TextInputVariant.OUTLINE"
          [width]="InputWidth.FULL"
          [attr.data-test-id]="'feature-session-timeout-input'"
        ></app-text-input>
        }
      </div>
      }
    </form>
  </section> </app-card
>}
